import { useSelector } from "react-redux";
import { CustomContainer, CustomTable, useFetch } from "../Tools";
import Forms from './Forms';
import { fetchSupervision, deleteSupervision } from "../../features/supervision/supervisionSlice";

const Supervision = () => {
    const { status, supervision } = useSelector(state => state.supervision)
    useFetch(status, fetchSupervision)
    const title = 'Supervisión'
    const headers = [{ name: 'Id', ref: 'id'}, { name: 'Clave', ref: 'clave'}, {name: 'Nombre', ref: 'nombre'}]
    return(
        <CustomContainer 
            title={title} 
            fnConfirm={deleteSupervision} 
            content={<CustomTable data={supervision} headers={headers} edit={true} remove={true} />}
            forms = {<Forms />}
        />
    )
}

export default Supervision;